<template>
    <div class="container-flud">
        <table class="table table-condensed" :class="{ 'table-hover': expandable }">
            <thead>
                <tr>
                    <th v-if="expandable"></th>
                    <th v-for="header in headers">
                        {{ header }}
                    </th>
                </tr>
            </thead>
            <tbody>
                <template v-for="(row,index) in rows">
                    <tr @click="toggleDetails(index)">
                        <td v-if="expandable">
                            <div class="details-expander">
                                <i class="fa fa-caret-right" v-show="!showingDetails(index)"></i>
                                <i class="fa fa-caret-down" v-show="showingDetails(index)"></i>
                            </div>
                        </td>
                        <td v-for="data in row.data">
                            {{ data }}
                        </td>
                    </tr>
                    <tr class="details" :class="{ expanded: showingDetails(index) }" v-if="expandable && Array.isArray(row.details)">
                        <td></td>
                        <td :colspan="row.data.length">
                            <div>
                                <table class="table table-condensed">
                                    <thead v-if="details_headers.length">
                                        <tr>
                                            <th v-for="header in details_headers">
                                                {{ header }}
                                            </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="detail in row.details">
                                            <td v-for="data in detail">
                                                {{ data }}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </td>
                    </tr>
                </template>
            </tbody>
        </table>
    </div>
</template>

<style lang="scss" scoped>
    @import '../../sass/_global_variables.scss';

    .details-expander {
        i {
            zoom: 1.2;
            width: 9px;
        }
    }

    tr:not(.details) {
        cursor: default;
    }

    tr.details {
        display: none;

        &.expanded {
            display: table-row;
        }
    }
</style>

<script>
    export default{
        props: {
            headers: { default() { return [] }},
            rows:  { default() { return [] }},
            expandable: { default: false },
            details_headers: { default() { return [] }}
        },

        data: function() {
            return {
                expanded: []
            }
        },

        methods: {
            showingDetails (row_index) {
                return this.expanded.includes(row_index)
            },
            toggleDetails (row_index) {
                if (this.showingDetails(row_index)) {
                    this.expanded.splice(this.expanded.indexOf(row_index),1)
                }
                else {
                    this.expanded.push(row_index)
                }
            }
        }
    }
</script>



// WEBPACK FOOTER //
// simple-table.vue?ba8357d4